module.exports = __webpack_public_path__ + "static/media/HOD.f329c333.png";